import { SxProps } from '@mui/system';

export const titleStyle: SxProps = {
  fontSize: '2.2rem',
  fontWeight: 700,
  textAlign: 'center',
  color: '#FFFFFF',
  background: '#FE9210',
  py: '1rem',
};

export const registerLinkStyle: SxProps = {
  fontSize: '1.8rem',
  textAlign: 'center',
  fontWeight: 700,
  my: '2rem',
};

export const infoContainerStyle: SxProps = {
  borderTop: '1px solid #CCCCCC',
};

export const infoStyle: SxProps = {
  fontSize: '1.6rem',
  textAlign: 'center',
  fontWeight: 500,
  my: '1rem',
};
